/** Shared visibility contract for Field and the Admin measurement mirror. */
export function motorMatchesSection(
  motor: { mechanismSectionCodes?: readonly string[] | null },
  sectionCode?: string | null,
): boolean {
  if (!sectionCode) return false;
  return motor.mechanismSectionCodes?.includes(sectionCode) ?? false;
}

/** Stable row ID is the only scope key; [] explicitly disables a motor. */
export function motorMatchesCornice(
  motor: { rowId: string; name: string },
  type: { motorCornices?: Record<string, string[]> } | null | undefined,
  corniceKey: string | null,
): boolean {
  const scope = type?.motorCornices?.[motor.rowId];
  if (scope == null) return true;
  if (corniceKey == null) return false;
  return scope.includes(corniceKey);
}
